<template>
    <div class="company-introduction-content-wrap" :class="!expanded && !showsMore ? undefined : 'pb-0'">
        <div class="company-introduction-content" :class="{ showsMore, expanded }" ref="content-box" v-bind="{ style }">
            <p v-html="content" class="page-text grey--text line-height-15" />
        </div>
        <v-fade-transition>
            <v-btn v-if="!expanded && !showsMore" absolute right bottom small outlined color="grey-d" style="z-index: 1" @click="showsMore = true">
                <span class="grey--text">더보기</span>
            </v-btn>
        </v-fade-transition>        
    </div>
</template>

<script>
export default {
    props: {
        content: { type: String },
        expanded: { type: Boolean, default: false },
    },
    data: () => ({
        showsMore: false,
    }),
    computed: {
        style() {
            const { scrollHeight } = this.$refs["content-box"] || {};
            if (this.showsMore || this.expanded) {
                if (scrollHeight) return `max-height:${scrollHeight}px;`;
                return `max-height:initial;`;
            } else return ``;
        },
    },
};
</script>


<style lang="scss" scoped>
::v-deep{
    .v-btn--absolute.v-btn--bottom.v-btn--right{
        bottom: 0;
        right: 0;
    }
}
.company-introduction-content {
    position: relative;
    max-height: 120px;

    overflow-y: hidden;
    white-space: pre-line;

    transition: max-height ease-in-out 0.2s;

    &::after {
        content: " ";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, transparent, white 100%);
        transition: opacity ease-in-out 0.2s;
    }

    &.expanded::after,
    &.showsMore::after {
        opacity: 0;
    }

    &-wrap{
        transition: max-height ease-in-out 0.2s;
        padding-bottom: 48px;
        position: relative;
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .company-introduction-content {
        &-wrap{
            padding-bottom: 76px;
        }
    }
    ::v-deep{
        .v-btn--absolute.v-btn--bottom.v-btn--right{
            padding: 0 24px;
        }
    }
}
@media (min-width:1200px){
}

</style>